const SENSITIVE = /(^|_|-)(api[-_]?key|authorization|token|password|secret|access[_-]?token|refresh[_-]?token)$/i;

export function redactDeep(v: unknown): unknown {
  if (Array.isArray(v)) return v.map(redactDeep);
  if (v && typeof v === 'object') {
    const out: any = Array.isArray(v) ? [] : {};
    for (const [k, val] of Object.entries(v as any)) {
      out[k] = SENSITIVE.test(k) ? '***' : redactDeep(val);
    }
    return out;
  }
  return v;
}

